import type { PollAnswer } from "@shared/types/api";

/** True when any option uses the optional rich fields, so the poll renders as option cards. */
export function hasRichAnswers(answers: PollAnswer[]): boolean {
  return answers.some((a) => a.imageUrl || a.subtitle || a.description || a.linkUrl || a.tags?.length);
}
